import { Component, Input, OnInit } from '@angular/core';
@Component({
    selector: 'simple-icons-webflow',
    template: `<svg class="simple-icons {{ className }}" [style.width]="size" [style.height]="size" [style.fill]="color" role="img" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><title>Webflow icon</title><path d="M17.802 8.56s-1.946 6.103-2.105 6.607a4778.8 4778.8 0 0 0-1.484-11.473c-3.316 0-5.089 2.36-6.026 4.851l-2.565 6.637c-.015-.476-.36-6.565-.36-6.565-.204-3.052-3-4.91-5.262-4.91l2.739 16.6c3.474-.015 5.347-2.361 6.328-4.852 0 0 2.09-5.398 2.176-5.643.015.23 1.5 10.494 1.5 10.494 3.488 0 5.362-2.202 6.37-4.606L24 3.708c-3.445 0-5.261 2.346-6.198 4.851Z"/></svg>`,
    styles: []
})
export class SimpleIconsWebflowComponent implements OnInit {
    @Input() size: string = '100%';
    @Input() color: string = '#4353FF';
    @Input() className: string = 'simple-icons-webflow'
    constructor() {}
    ngOnInit(): void {}
}
